import { render, staticRenderFns } from "./RiderTales.vue?vue&type=template&id=7869df34"
import script from "./RiderTales.vue?vue&type=script&lang=js"
export * from "./RiderTales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports